import axios from '../../plugins/axios'

export const listPasswords = ({ commit }, payload) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: payload ? payload.params : null
  }
  return axios.get('/api/password', config)
    .then((response) => {
      const passwords = response.data;
      commit('SET_PASSWORDS', { passwords })
    },
    (error) => {
      console.log(error);
    })
};
export const editPassword = ({}, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.put(`/api/password/${data.id}`, data, config)
    .then((response) => response )
    .catch((error) => error.response );
};

export const deletePassword = ({}, id) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.delete(`/api/password/${id}`, config)
    .then((response) => response )
    .catch((error) => error.response );
}

export const createPassword = ({}, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.post('/api/password', data, config)
    .then((response) => response )
    .catch((error) => error.response );
}

export const getPassword = ({commit}, id) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.get(`/api/password/${id}`, config)
    .then((response) => {
      const password = response.data;
      commit('SET_PASSWORD', { password });
    })
    .catch((error) => error.response );
}